import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PortfolioReel } from '@/components/landing/portfolio-reel'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <PortfolioReel />
        </Layout>
    )
}

export default Home
